import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function OrderBumpSection() {
  const [isOpen, setIsOpen] = useState(false);
  return <section className="pt-8 pb-12 px-5" data-id="element-175">
      <div className="max-w-lg mx-auto" data-id="element-176">
        <div className="glass-teal rounded-2xl border-2 border-teal p-6 relative overflow-hidden shadow-[0_0_30px_rgba(45,212,191,0.15)] flex flex-col" data-id="element-177">
          {/* Subtle glow effect behind */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-teal/10 blur-2xl -z-10" data-id="element-178"></div>

          <div className="text-center mb-6" data-id="element-179">
            <h3 className="text-lg font-bold text-teal tracking-wide" data-id="element-180">
              🔥 SOLUCIÓN COMPLETA PARA TU HOGAR
            </h3>
          </div>

          <div className="mb-6 flex justify-center" data-id="element-181">
            <img src="https://cdn.magicpatterns.com/uploads/gCg9R754gKbiKGTrnR2xKP/fotoorderbump.png" alt="El Código del Silencio - Manual Anti-Ansiedad" className="w-4/5 h-auto rounded-xl shadow-lg border border-teal/20" data-id="element-182" />
          </div>

          <div className="text-center mb-6" data-id="element-183">
            <p className="text-white leading-relaxed mb-6" data-id="element-184">
              Añade "El Código del Silencio". Evita destrozos y quejas de
              vecinos cuando lo dejas solo. El manual definitivo anti-ansiedad
              que el 85% añade a su pedido.
            </p>

            <div className="glass-strong px-5 py-2.5 rounded-full inline-flex items-center justify-center border-teal/30" data-id="element-185">
              <span className="font-bold text-white tracking-wide" data-id="element-186">
                Solo +8,90€{' '}
                <span className="text-white/60 font-normal" data-id="element-187">
                  (Un solo pago)
                </span>
              </span>
            </div>
          </div>

          {/* Accordion */}
          <div className="mt-auto pt-4 border-t border-teal/20" data-id="element-188">
            <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between text-left focus:outline-none group" data-id="element-189">
              <span className="text-sm font-semibold text-teal group-hover:text-teal-dark transition-colors" data-id="element-190">
                ¿Cómo protege mi hogar?
              </span>
              <ChevronDown className={`w-4 h-4 text-teal/70 transition-transform duration-300 ${isOpen ? 'rotate-180 text-teal' : ''}`} data-id="element-191" />
            </button>
            <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100 mt-4' : 'max-h-0 opacity-0'}`} data-id="element-192">
              <div className="p-4 rounded-xl bg-teal/5 border border-teal/10 space-y-3 text-sm text-white/80 text-left" data-id="element-193">
                <p data-id="element-194">
                  El manual definitivo para eliminar la Ansiedad por Separación
                  antes de que se convierta en un problema legal o de
                  convivencia.
                </p>
                <p data-id="element-195">
                  <strong className="text-white" data-id="element-196">
                    El Ritual de Salida 'Sordo':
                  </strong>{' '}
                  Cómo romper la asociación de las llaves y zapatos con el
                  pánico.
                </p>
                <p data-id="element-197">
                  <strong className="text-white" data-id="element-198">Cero Destrozos:</strong> La
                  técnica de la 'Habitación Segura' para que tu sofá y puertas
                  sobrevivan a tu ausencia.
                </p>
                <p data-id="element-199">
                  <strong className="text-white" data-id="element-200">Monitorización 2026:</strong>{' '}
                  Cómo usar tecnología gratuita para saber si tu perro está
                  tranquilo en tiempo real.
                </p>
                <p data-id="element-201">
                  <strong className="text-white" data-id="element-202">Resultado:</strong> Sal de casa
                  con la tranquilidad de que tu perro está en silencio y
                  relajado.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}